import { useApi } from './apiService';

export const useDeviceManagementService = () => {
  const api = useApi();

  const getDeviceManagementBanner = async (tenantId: string) => {
    const response = await api.get(`agentapi/AgentDeviceManagement/${tenantId}/device-management-banner`);
    return response.data;
  };

  const getDeviceManagementData = async (params: {
    tenantId: string;
    pageNumber: number;
    pageSize: number;
    search?: string | null;
    tenantGroupId?: string | null;
    criteria?: string | null;
  }) => {
    const { tenantId, pageNumber, pageSize, search, tenantGroupId, criteria } = params;
    const qs = new URLSearchParams({
      pageNumber: pageNumber.toString(),
      pageSize: pageSize.toString(),
    });
    if (search?.trim()) qs.append('search', search.trim());
    if (tenantGroupId?.trim()) qs.append('tenantGroupId', tenantGroupId.trim());

    let url = `agentapi/AgentDeviceManagement/${tenantId}/agent-endpoints`;
    if (criteria) url += `/${criteria}`;

    const response = await api.get(`${url}?${qs.toString()}`);
    return response.data; // expect { data, pagination, ... }
  };

  const syncEndpoints = async (tenantId: string, agentIdList: string[]) => {
    const response = await api.post(`patchcenterservice/RemediationPlan/${tenantId}/endpoint-sync-list`, JSON.stringify({ agentIdList }));
    return response.data;
  };

  const rebootDevices = async (tenantId: string, agentIdList: string[]) => {
    const response = await api.post(`patchcenterservice/RemediationPlan/${tenantId}/reboot-device-list`, JSON.stringify({ agentIdList }));
    return response.data;
  };

  const shutdownDevices = async (tenantId: string, agentIdList: string[]) => {
    const response = await api.post(`patchcenterservice/RemediationPlan/${tenantId}/shutdown-device-list`, JSON.stringify({ agentIdList }));
    return response.data;
  };

  const deactivateAgents = async (tenantId: string, agentIdList: string[]) => {
    const response = await api.put(`tenantservice/Tenant/${tenantId}/disable-tenant`, JSON.stringify({ agentIdList }));
    return response.data;
  };

  const getEndpointsForCsv = async (tenantId: string, deviceHealth?: string) => {
    const suffix = deviceHealth ? `/${deviceHealth}` : '';
    const response = await api.get(`agentapi/AgentDeviceManagement/${tenantId}/agent-endpoints${suffix}`);
    return response.data;
  };

  return {
    getDeviceManagementBanner,
    getDeviceManagementData,
    syncEndpoints,
    rebootDevices,
    shutdownDevices,
    deactivateAgents,
    getEndpointsForCsv,
  };
};
